import { TextField, TextFieldProps } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import React from 'react';
import Icon from './icon.component';

export default function PasswordTextFieldComponent(props: TextFieldProps) {
	const [startLongPress, setStartLongPress] = React.useState(false);
	const ms = 100;

	React.useEffect(() => {
		let timerId: NodeJS.Timeout;
		if (startLongPress) {
			timerId = setTimeout(() => {}, ms);
		} else {
			clearTimeout(timerId);
		}

		return () => {
			clearTimeout(timerId);
		};
	}, [ms, startLongPress]);

	const handleMouseDown = React.useCallback(() => {
		setStartLongPress(true);
	}, []);

	const handleMouseUp = React.useCallback(() => {
		setStartLongPress(false);
	}, []);

	return (
		<TextField
			{...props}
			type={startLongPress ? 'text' : 'password'}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<IconButton onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp} edge='end'>
							{startLongPress ? (
								<Icon name='eye' style={{ transform: 'translateY(-2.1px)' }} />
							) : (
								<Icon name='eye-slash' style={{ transform: 'translateY(-1.33px)' }} />
							)}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
}



// WEBPACK FOOTER //
// ./src/components/shared/password-text-field.component.tsx